<template>
  <div id="qxTabPage">
    <!-- 订货中心订单查询 -->
    <div class="orderTable">
      <div class="titleList">
        <div class="threeHead">
          <div class="name firstCol">商品描述</div>
          <div class="name twoCol">状态</div>
          <div class="name fourCol">数量</div>
          <div class="name fiveCol">总价</div>
          <div class="name sixCol">店铺名称</div>
          <div class="name sixCol">联系商家</div>
          <div class="name sevenCol">操作</div>
        </div>

      </div>
      <div class="resultList">
        <div v-for="(item,index) of tableData" :key="index" class="itemResult">
          <div class="descInfo">
            <div class="leftImg">
              <img :src="currentIndex==4 ? item.note :item.orderDetail.commodityImg" alt="">
            </div>
            <div v-if="currentIndex==4" class="rightInfo">
              <div class="name fixsubray" @click="goorderDetail(item)">{{ item.commodityName }}</div>
              <div v-if="item.symbolId==1" class="price fixsubray"> ¥{{ item.price }}</div>
              <div v-else class="price fixsubray"> {{ item.price }}{{ item.symbolNameCh }}</div>
            </div>
            <div v-else class="rightInfo">
              <div class="name fixsubray" @click="goorderDetail(item)">{{ item.commodityName }}</div>
              <div v-if="item.symbolId==1" class="price fixsubray"> ¥{{ item.orderDetail.price }}</div>
              <div v-else class="price fixsubray"> {{ item.orderDetail.price }}{{ item.symbolNameCh }}</div>
            </div>
          </div>
          <div v-if="currentIndex==4" class="twoCol fixsubray topSty">
            {{ item.auditStatus | auditStatusFormat }}
          </div>
          <div v-else class="twoCol fixsubray topSty">
            {{ item.orderDetail?.orderStatus | statusFormat }}
          </div>
          <div class="fourCol topSty">
            {{ currentIndex==4 ? item.quantity : item.orderDetail.amount }}
          </div>
          <div v-if="item.symbolId==1" class="fiveCol topSty">
            ¥{{ currentIndex==4 ? item.totalAmount : item.actualPayPrice }}
          </div>
          <div v-else class="fiveCol topSty">
            {{ item.actualPayPrice }}{{ item.symbolNameCh }}
          </div>
          <div class="sixCol topSty">
            {{ item.storeName }}
          </div>
          <div class="sixCol topSty">
            {{ currentIndex==4 ? item.contactInfo : item.contactCellphone }}
          </div>
          <div class="actionInfo topSty">
            <span v-if="item.orderDetail?.orderStatus==1" class="curPont" @click="sureReive(item.orderDetail.orderDetailId)"> 确认收货</span>
            <span v-if="item.orderDetail?.orderStatus==1 || item.orderDetail?.orderStatus==2" class="curPont" @click="viewLogist(item)"> 查看物流</span>
            <span v-if="item.isShowTk" class="curPont" @click="showReundPop(item)"> 申请退款</span>
            <!-- 认购商品  申请认购订单退回金额 -->
            <span v-if="item.orderDetail?.mallFlag === 'T' && [18, 19].includes(item.orderDetail?.orderStatus)" class="curPont" @click="showRGRPop(item)"> 申请认购退款</span>
            <!-- 认购商品  申请认购订单发货 -->
            <span v-if="item.orderDetail?.mallFlag === 'T' && item.orderDetail?.orderStatus==19" class="curPont" @click="showRGSPop(item)"> 申请发货</span>
            <span class="curPont" @click="goorderDetail(item)"> 详情</span>
          </div>
        </div>
        <template v-if="tableData.length==0">
          <div v-if="isNetWrong" class="no-datas1"><div class="no-data-img" style="margin: 200px auto 0px; width: 100px; height: 400px;"><img src="../../../assets/images/no_data.png" alt="" style="width: 100%;"></div><div class="no-data" style="margin-top: 10px !important; text-align: center;" @click="showsData">加载失败,点击重试</div></div>
          <div v-else class="no-datas1"><div class="no-data-img" style="margin: 200px auto 0px; width: 100px; height: 100px;"><img src="../../../assets/images/no_data.png" alt="" style="width: 100%;"></div><div class="no-data" style="margin-top: 10px !important; text-align: center;">暂无数据</div></div>
        </template>
      </div>
      <el-row v-if="pageData.total">
        <el-col :span="24" class="paginateWrap">
          <el-pagination
            popper-class="_popStyle"
            :current-page="pageData.currentPage"
            :page-sizes="pageData.pageSizes"
            :page-size="pageData.pageSize"
            layout="total, sizes, prev, pager, next"
            :total="pageData.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
    <!-- 确认收货弹框 -->
    <sureLogistPop ref="surelogist" name="order" @reQueryList="reQuerysList"></sureLogistPop>
    <!-- 订单详情 -->
    <detailPop ref="detailPop" name="qy"></detailPop>
    <!-- 物流详情 -->
    <orderLogistics ref="orderLogistics" />
    <!-- 退款详情 -->
    <el-dialog
      class="refundDialog"
      title=""
      :visible.sync="refundDetailPop"
      :close-on-click-modal="false"
      width="480px"
    >
      <div class="logistics">
        <div class="title">退款详情</div>
        <div class="desRefundInfo">
          <div class="bwtSty">
            <span class="name">退款状态</span>
            <span class="reslut">{{ refDetailObj.auditStatus | auditStatusFormat }}</span>
          </div>
          <div v-if="refDetailObj.auditStatus===3" class="bwtSty">
            <span class="name">驳回原因</span>
            <span class="reslut" :class="refDetailObj.rejectAnswer.length>16?'leftSty':''">{{ refDetailObj.rejectAnswer }}</span>
          </div>
          <div class="bwtSty">
            <span class="name">申请时间</span>
            <span class="reslut">{{ refDetailObj.createTime | dateFormate }}</span>
          </div>
          <div class="bwtSty">
            <span class="name">退款金额</span>
            <span v-if="refDetailObj.symbolId==1" class="reslut amounts">¥{{ refDetailObj.totalAmount }}</span>
            <span v-else class="reslut amounts">{{ refDetailObj.totalAmount }}{{ refDetailObj.symbolNameCh }}</span>
          </div>
        </div>
        <div class="inputWrap">
          <div class="name">退款原因</div>
          <div>
            <el-input v-model="refDetailObj.notes" :disabled="true" type="textarea" placeholder="详细说明退款原因，有助于商家更好的处理售后问题" maxlength="100" show-word-limit></el-input>
          </div>
        </div>
        <div v-if="refDetailObj?.orderStatus==1 && refDetailObj.auditStatus==2" class="detailRow">
          <div class="twosRow threesRow">
            <p class="btwSty">
              <span class="name">快递名称</span>
              <span class="price">{{ refDetailObj.logisticsName }}</span>
            </p>
            <div class="btwSty">
              <span class="name">快递单号</span>
              <div class="rightInfo">
                <span class="orderNo">{{ refDetailObj.logisticsNumber }} | </span>
                <span
                  v-clipboard:copy=" refDetailObj.logisticsNumber"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                  class="copyInfo"
                >复制</span>
              </div>
            </div>
            <p class="btwSty">
              <span class="name">发货时间</span>
              <span class="time">{{ refDetailObj.deliveryTime | dateFormate }}</span>
            </p>
          </div>
        </div>
        <div class="actionWrap">
          <!-- <span class="btns" @click="refundDetailPop=false">取消</span> -->
          <span class="savebtn" @click="refundDetailPop=false">确定</span>
        </div>
      </div>
    </el-dialog>
    <!-- 申请退款 -->
    <el-dialog
      class="refundDialog"
      title=""
      :visible.sync="refundDialog"
      :close-on-click-modal="false"
      width="480px"
    >
      <div class="logistics">
        <div class="title">申请退款</div>
        <div class="desInfo">
          <span class="name">退款金额</span>
          <span v-if="refundObj.symbolNameCh=='人民币'" class="price">¥{{ refundObj.money }}</span>
          <span v-else class="price">{{ refundObj.money }}{{ refundObj.symbolNameCh }}</span>
        </div>
        <div class="inputWrap">
          <div class="name">退款原因</div>
          <div>
            <el-input v-model="reason" type="textarea" placeholder="详细说明退款原因，有助于商家更好的处理售后问题" maxlength="100" show-word-limit></el-input>
          </div>
        </div>
        <div class="actionWrap">
          <span class="btns" @click="refundDialog=false">取消</span>
          <span class="savebtn" @click="applyRefund()">确定</span>
        </div>
      </div>
    </el-dialog>
    <!-- 认购商品申请退款 -->
    <el-dialog
      class="refundDialog"
      title=""
      :visible.sync="RGODialog"
      :close-on-click-modal="false"
      width="480px"
    >
      <div class="logistics">
        <div class="title">申请认购退款</div>
        <div class="actionWrap">
          <span class="btns" @click="RGODialog=false">取消</span>
          <span class="savebtn" @click="applyRGR()">确定</span>
        </div>
      </div>
    </el-dialog>
    <!-- 认购商品申请发货 -->
    <el-dialog
      class="refundDialog"
      title=""
      :visible.sync="RGSDialog"
      :close-on-click-modal="false"
      width="480px"
    >
      <div class="logistics">
        <div class="title">申请认购发货</div>
        <div class="actionWrap">
          <span class="btns" @click="RGSDialog=false">取消</span>
          <span class="savebtn" @click="applyRGS()">确定</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
/*global http protocol util */
import sureLogistPop from '../dhOrderTab/sureLogistPop.vue'
import detailPop from '../dhOrderTab/orderDetailPop.vue'
import orderLogistics from '../dhOrderTab/orderLogistics.vue'
export default {
  components: {
    sureLogistPop,
    detailPop,
    orderLogistics
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ['currentIndex'],
  data() {
    return {
      tableData: [],
      showLogistics: false,
      logistInfo: '',
      conctInfo: '',
      showConct: false,
      statusObj: {
        orderStatus: null,
        payStatus: null,
        orderStatusList: null
      },
      pageData: {
        total: null,
        pageSizes: [10, 20, 30, 40],
        pageSize: 20,
        currentPage: 1
      },
      isNetWrong: false,
      refundDialog: false,
      reason: null,
      refundObj: {
        detailId: null,
        money: null, // 不包含运费
        symbolNameCh: null
      },
      isRepeat: false,
      refundDetailPop: false,
      refDetailObj: {
        amount: null,
        auditStatus: null,
        commodityId: null,
        commodityName: null,
        createTime: null,
        firmId: null,
        id: null,
        note: null,
        notes: '',
        orderCode: null,
        orderId: null,
        payTime: null,
        price: null,
        quantity: null,
        rejectAnswer: '',
        singlePrice: null,
        totalAmount: null,
        orderDetailId: null,
        updateTime: null
      },
      rengouType: [18, 19, 20, 21, 22], // 认购
      RGODialog: false, // 认购退款
      RGOObj: { // 认购退款
        detailId: null,
        money: null, // 不包含运费
        symbolNameCh: null
      },
      RGSDialog: false, // 认购发货
      RGSObj: { // 认购发货
        detailId: null,
        money: null, // 不包含运费
        symbolNameCh: null
      },
      APP_TITLE_NAME: window.g.APP_TITLE_ALL
    }
  },
  watch: {
    currentIndex(tab) {
      // this.tableData = []
      this.inits(tab)
    }
  },
  mounted() {
    this.inits(this.currentIndex)
    // this.showsData()
  },
  methods: {
    inits(tab) {
      if (tab === 1) { // 待发货
        this.statusObj.orderStatus = 0
        this.statusObj.orderStatusList = null
        this.statusObj.payStatus = 1
      } else if (tab === 2) { // 待收货
        this.statusObj.orderStatus = 1
        this.statusObj.orderStatusList = null
        this.statusObj.payStatus = 1
      } else if (tab === 3) { // 已完成
        this.statusObj.orderStatus = 2
        this.statusObj.orderStatusList = null
        this.statusObj.payStatus = 1
      } else if (tab === 4) { // 退款/售后
        // this.statusObj.orderStatus = 2
        // this.statusObj.payStatus = 1
      } else if (tab === 5) { // 定购商品
        this.statusObj.orderStatus = null
        this.statusObj.orderStatusList = this.rengouType
        this.statusObj.payStatus = null
      } else { // 全部
        this.statusObj.orderStatus = null
        this.statusObj.orderStatusList = null
        this.statusObj.payStatus = null
      }
      this.pageData.currentPage = 1
      this.tableData = []
      this.showsData()
    },
    // 分页
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.showsData()
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.showsData()
    },
    deliverDateFormate(timer) { // 发货时间不含分秒
      const date = new Date(timer)
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      const hour = date.getHours()
      const newDay = `${year}-${month}-${day} ${hour}:00:00`
      return new Date(newDay).getTime()
    },
    reQuerysList() {
      setTimeout(() => {
        this.showsData()
      }, 1500)
    },
    calcTime(time, autoReceiveDeadline) {
      // 倒计时 8天4小时
      // 如果1号13:01发货，自动收货确认时间是13:00 省略分钟
      // 如果1号13:00发货 ，自动收货确认时间是13:00
      // 处理发货时间
      const deliverDayTime = this.deliverDateFormate(time)
      const currentTime = this.deliverDateFormate(new Date().getTime())
      const lastTime = deliverDayTime + autoReceiveDeadline * 24 * 60 * 60 * 1000
      const leftTime = (lastTime - currentTime) // 剩余多少时间毫秒  + 1 * 24 * 60 * 60 * 1000
      const day = parseInt(leftTime / (3600000 * 24))
      const hour = parseInt((leftTime % (3600000 * 24)) / 3600000)
      return (day > 0 ? (day + '天') : '') + (hour > 0 ? (hour + '小时') : '')
      // if (this.countDown) { // 不考虑在页面停留一小时的情况
      //   this.timer = setInterval(() => {
      //     if (hour > 1) { // 存在天和小时 存在小时不存在天
      //       hour = hour - 1
      //       this.countDown = (day > 0 ? (day + '天') : '') + (hour > 0 ? (hour + '小时') : '')
      //     } else if (day > 0) { // 存在天没有小时
      //       day = day - 1
      //       hour = 5
      //       this.countDown = (day > 0 ? (day + '天') : '') + (hour > 0 ? (hour + '小时') : '')
      //     } else { // 小时和天都不存在
      //       day = 0
      //       hour = 0
      //       this.countDown = ''
      //       clearInterval(this.timer)
      //       this.timer = null
      //     }
      //   }, 3600000)
      // }
    },
    // 订单展示
    showsData() {
      const that = this
      let currentProtocol = protocol.param_queryShopOrderInfo
      if (this.currentIndex == 4) {
        currentProtocol = protocol.param_queryGoodBackInfo
        currentProtocol.param.orderIdTrue = null
      } else if (this.currentIndex == 5) {
        currentProtocol.param.mallFlag = null
        currentProtocol.param.orderStatus = this.statusObj.orderStatus
        currentProtocol.param.payStatus = this.statusObj.payStatus
        currentProtocol.param.orderStatusList = this.statusObj.orderStatusList
      } else {
        currentProtocol.param.mallFlag = 'I'
        currentProtocol.param.orderStatus = this.statusObj.orderStatus
        currentProtocol.param.payStatus = this.statusObj.payStatus
        currentProtocol.param.orderStatusList = this.statusObj.orderStatusList
      }
      currentProtocol.param.page = this.pageData.currentPage - 1
      currentProtocol.param.size = this.pageData.pageSize
      currentProtocol.param.sort = [
        {
          direction: 'DESC',
          property: 'createTime'
        }
      ]
      http.postFrontMall(currentProtocol).then(response => {
        if (response.data.code != 0) {
          this.$message({ message: response.data.message })
          this.isNetWrong = true
        } else {
          this.isNetWrong = false
        }
        if (response.data) {
          if (response.data && response.data.code == '0') {
            this.pageData.total = response.data.value.totalElements
            const { value } = response.data
            if (this.currentIndex !== 4) {
              for (let i = 0; i < value.content.length; i++) {
                value.content[i].orderDetail.commodityImg = value.content[i].commodityPicture.find(item => item.isMain === '1').img
                const reate = value.content[i].orderKind === 'R' ? value.content[i].retailRate : value.content[i].purchaseRate
                const oldPrice = util.floatMul(value.content[i].orderDetail.price, value.content[i].orderDetail.amount)
                value.content[i].rewardNum = Number(Number(util.floatMul(oldPrice, reate)).toFixed(2)).toPrecision()
                // eslint-disable-next-line eqeqeq
                value.content[i].orderStatus = value.content[i].orderDetail.orderStatus
                if (value.content[i].orderDetail.orderStatus == 0) {
                  // const returnDeadline = value.content[i].returnDeadline * 24 * 60 * 60 * 1000 // 剩余可取消的期限毫秒
                  // const currentTime = new Date().getTime()
                  // const leftTime = currentTime - value.content[i].createTime // 过了多长时间
                  // if (leftTime < returnDeadline) {
                  value.content[i].isShowTk = true
                  // } else {
                  //   value.content[i].isShowTk = false
                  // }
                  // eslint-disable-next-line eqeqeq
                } else {
                  value.content[i].isShowTk = false
                }
              }
              this.tableData = value.content
            } else {
              this.tableData = value.content
            }
          }
        }
      }).catch((e) => {
        setTimeout(() => {
          that.showsData()
        }, 1000)
      })
    },
    sureReive(orderDetailId) {
      this.$refs.surelogist.showDialog(orderDetailId)
    },
    viewLogist(item) {
      // if (this.APP_TITLE_NAME === '神农购销') {
      //   protocol.param_getLogistic.url = '/shop-desk/aliDelivery/getLogistic'
      // } else {
      //   protocol.param_getLogistic.url = '/shop-admin/aliDelivery/getLogistic'
      // }
      protocol.param_getLogistic.param.no = item.orderDetail.logisticsNumber + ':' + item.cellphone.slice(-4)
      protocol.param_getLogistic.param.type = item.orderDetail.logisticsCompany
      http
        .postFrontMall(protocol.param_getLogistic)
        .then(response => {
          const { code, message, value } = response.data
          if (code === 0 || code === '0') {
            sessionStorage.setItem('logiticObj', JSON.stringify(value))
            sessionStorage.setItem('goodImg', value.logo)
            this.$refs.orderLogistics.getLogistic()
          } else {
            this.$message(message)
          }
        })
        .catch(() => {})
    },
    showReundPop(row) {
      // protocol.param_findShopOrderDetailInfo.param.orderId = id
      // http
      //   .postFrontMall(protocol.param_findShopOrderDetailInfo)
      //   .then(response => {
      //     const { code, message, value } = response.data
      //     if (code === 0 || code === '0') {
      //       const commodityAndRec = value.commodityAndRec.content.length ? value.commodityAndRec.content[0] : {}
      //       const totalPrice = value.totalPrice
      //       this.refundObj = {
      //         detailId: commodityAndRec.orderDetailId,
      //         money: totalPrice, // 不包含运费
      //         symbolNameCh: value.symbolNameCh
      //       }
      //       this.refundDialog = true
      //     } else {
      //       this.$message(message)
      //     }
      //   })
      //   .catch(() => {})
      this.refundObj = {
        detailId: row.orderDetail.orderDetailId,
        money: row.totalPrice, // 不包含运费
        symbolNameCh: row.symbolNameCh
      }
      this.reason = '' // 清空输入历史
      this.refundDialog = true
    },
    // 申请退款
    applyRefund() {
      if (!this.reason || !this.reason.trim('')) {
        return this.$message('请输入退款原因')
      }
      if (!this.isRepeat) {
        this.isRepeat = true
      } else {
        return
      }
      protocol.param_refundOrder.param.notes = this.reason
      protocol.param_refundOrder.param.orderDetailId = this.refundObj.detailId
      http.postFrontMall(protocol.param_refundOrder).then((response) => {
        const { code, message } = response.data
        this.isRepeat = false
        this.$message(message)
        if (Number(code) === 0) {
          setTimeout(() => {
            this.refundDialog = false
            this.$emit('changeId')
          }, 2000)
        }
      }).catch(() => {
        this.isRepeat = false
      })
    },
    // 申请认购商品退款 弹窗
    showRGRPop(row) {
      this.RGOObj = {
        detailId: row.orderDetail.orderDetailId,
        // money: row.totalPrice, // 不包含运费
        // symbolNameCh: row.symbolNameCh
      }
      this.RGODialog = true
    },
    // 申请认购商品退款
    applyRGR() {
      if (!this.isRepeat) {
        this.isRepeat = true
      } else {
        return
      }
      protocol.param_applyReturnFunds.param.orderDetailId = this.RGOObj.detailId
      console.log('param_applyReturnFunds', this.RGOObj.detailId)
      http.postFrontMall(protocol.param_applyReturnFunds).then((response) => {
        const { code, message } = response.data
        this.isRepeat = false
        this.$message(message)
        if (Number(code) === 0) {
          this.RGODialog = false
          setTimeout(() => {
            this.$emit('changeId')
          }, 2000)
        }
      }).catch(() => {
        this.isRepeat = false
      })
    },
    // 申请认购商品发货 弹窗
    showRGSPop(row) {
      this.RGSObj = {
        detailId: row.orderDetail.orderDetailId,
        // money: row.totalPrice, // 不包含运费
        // symbolNameCh: row.symbolNameCh
      }
      this.RGSDialog = true
    },
    // 申请认购商品发货
    applyRGS() {
      if (!this.isRepeat) {
        this.isRepeat = true
      } else {
        return
      }
      protocol.param_applySend.param.orderDetailId = this.RGSObj.detailId
      http.postFrontMall(protocol.param_applySend).then((response) => {
        const { code, message } = response.data
        this.isRepeat = false
        this.$message(message)
        if (Number(code) === 0) {
          this.RGSDialog = false
          setTimeout(() => {
            this.$emit('changeId')
          }, 2000)
        }
      }).catch(() => {
        this.isRepeat = false
      })
    },
    goorderDetail(row) {
      if (this.currentIndex === 4 || row.orderStatus === 9 || row.orderStatus === 3) {
        // 售后弹框
        if (this.currentIndex === 4) {
          this.refDetailObj = row
          if (!row.rejectAnswer) {
            this.refDetailObj.rejectAnswer = ''
          }
          this.refundDetailPop = true
        } else {
          protocol.param_queryGoodBackInfo.param.page = 0
          protocol.param_queryGoodBackInfo.param.size = 10
          protocol.param_queryGoodBackInfo.param.sort = [
            {
              direction: 'DESC',
              property: 'createTime'
            }
          ]
          protocol.param_queryGoodBackInfo.param.orderIdTrue = row.orderDetail.orderId
          http
            .postFrontMall(protocol.param_queryGoodBackInfo)
            .then(response => {
              const { code, message, value } = response.data
              this.loading = false
              if (code === 0 || code === '0') {
                this.refDetailObj = value.content[0]
                if (!this.refDetailObj.rejectAnswer) {
                  this.refDetailObj.rejectAnswer = ''
                }
                this.refundDetailPop = true
              } else {
                this.$message(message)
              }
            })
            .catch(() => {})
        }
      } else {
        // 详情弹框
        this.$refs.detailPop.showDialog(row)
      }
    }

  }

}
</script>
    <style lang="scss" scoped>
    .refundDialog{
      /deep/.el-dialog{
          background: #424556!important;
          border-radius: 8px 8px 8px 8px;
      }
      /deep/.el-dialog__header{
          display: none;
      }
      /deep/.el-dialog__body{
          padding:40px;
      }
      .title{
          font-size: 24px;
          font-family: Alibaba PuHuiTi-Bold, Alibaba PuHuiTi;
          font-weight: bold;
          color: #FFFFFF;
          text-align: center;
      }
    .desInfo{
      margin-top:20px;
      height: 45px;
      background: #292C3A;
      border-radius: 4px 4px 4px 4px;
      padding:0 10px;
      display: flex;
      justify-content: space-between;
      align-items:center;
      .name{
        font-size: 18px;
        font-family: Alibaba PuHuiTi-Bold, Alibaba PuHuiTi;
        font-weight: bold;
        color: #fff;
      }
      .price{
        font-size: 20px;
        font-family: ITC Avant Garde Gothic Pro-Demi, ITC Avant Garde Gothic Pro;
        font-weight: normal;
        color: #FFFFFF;
      }
    }
    .inputWrap{
      margin-top:20px;
      .name{
        margin-bottom:10px;
        font-size: 16px;
        font-family: Alibaba PuHuiTi-Regular, Alibaba PuHuiTi;
        font-weight: 400;
        color: #C5C5C5;
        line-height: 19px;
      }
      /deep/.el-textarea__inner{
        height: 100px;
        background: #292C3A;
        border-radius: 4px 4px 4px 4px;
        border:none;
        padding:10px 20px;
        font-size: 16px;
        font-family: Alibaba PuHuiTi-Bold, Alibaba PuHuiTi;
        font-weight: bold;
        color: #FFFFFF;
      }
      /deep/.el-textarea .el-input__count{
        background: #292C3A;
      }
    }
    .actionWrap{
          margin-top:40px;
          display: flex;
          justify-content: center;
          .btns{
              display: inline-block;
              width: 95px;
              height: 40px;
              background: #FCECC8;
              border-radius: 4px 4px 4px 4px;
              border: 1px solid #E4CA91;
              font-size: 14px;
              font-family: PingFang HK-Medium, PingFang HK;
              font-weight: 500;
              color: #5E4207;
              line-height: 40px;
              text-align: center;
              cursor: pointer;
          }
      }

      .savebtn{
          margin-left: 20px;
          width:95px;
          display: inline-block;
          height: 40px;
          background: #E4CA91;
          border-radius: 4px 4px 4px 4px;
          font-size: 14px;
          font-family: PingFang HK-Medium, PingFang HK;
          font-weight: 500;
          color: #5E4207;
          text-align: center;
          line-height: 40px;
          cursor: pointer;
      }
    .desRefundInfo{
      margin-top:10px;
      background: #292C3A;
      border-radius: 4px 4px 4px 4px;
      padding:0 10px 10px;
      .bwtSty{
        padding-top:10px;
        display: flex;
        justify-content: space-between;
        // align-items:center;
        .name{
          width:80px;
          font-size: 18px;
          font-family: Alibaba PuHuiTi-Regular, Alibaba PuHuiTi;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 21px;
        }
        .reslut{
          width:calc(100% - 80px);
          font-size: 18px;
          font-family: Alibaba PuHuiTi-Regular, Alibaba PuHuiTi;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 21px;
          text-align: right;
        }
        .leftSty{
          text-align: left;
        }
        .amounts{
          font-size: 20px;
          font-family: ITC Avant Garde Gothic Pro-Demi, ITC Avant Garde Gothic Pro;
          font-weight: normal;
          color: #FFFFFF;
          line-height: 23px;
        }
      }
    }
    }
  .titleList{
      width:100%;
      height: 40px;
      background: linear-gradient(180deg, #1F243C 0%, #323855 100%);
      box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.5);
      .threeHead{
        width:95.84%;
        height: 40px;
        margin:0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding:0px 40px;
        box-sizing: border-box;
      }
      .name{
          font-size: 18px;
          font-family: PingFang HK-Semibold, PingFang HK;
          font-weight: 600;
          color: rgba(255,255,255,0.6);
      }
      .firstCol{
          flex:2;
      }
      .twoCol{
          flex:1;
      }
      .threeCol{
          flex:1;
      }
      .fourCol{
          flex:1;
      }
      .fiveCol{
          flex:1;
      }
      .sixCol{
          flex:1.2;
      }
      .sevenCol{
          flex:1;
          text-align: right;
      }
  }
  .resultList{
      width:95.84%;
      margin:0 auto;
      margin-bottom: 52px;
      .itemResult{
          margin-top:20px;
          background: #343646;
          border-radius: 4px 4px 4px 4px;
          padding:20px 40px;
          display: flex;
          justify-content: space-between;
          .descInfo{
              flex:2;
              display: flex;
              align-items: center;
              .leftImg{
                  width: 80px;
                  margin-right: 20px;
                  img{
                      width: 80px;
                      height: 80px;
                      border-radius: 4px 4px 4px 4px;
                  }
              }
              .rightInfo{
                  .name{
                    color:#E4CA91;
                      word-break: break-all;
                      text-overflow: ellipsis;
                      display: -webkit-box;
                      -webkit-box-orient: vertical;
                      -webkit-line-clamp: 1; /* 这里是超出几行省略 */
                      overflow: hidden;
                      cursor: pointer;
                  }
                  .price{
                      margin-top:10px;

                  }
              }
          }
          .fixsubray{
              font-size: 18px;
              font-family: Alibaba PuHuiTi-Regular, Alibaba PuHuiTi;
              font-weight: 400;
              color: #CCCCCC;
              line-height: 21px;
          }
          .twoCol{
              flex:1;
          }
          .threeCol{
              flex:1;
          }
          .fourCol{
              flex:1;
              font-size: 22px;
              font-family: ITC Avant Garde Gothic Pro-Demi, ITC Avant Garde Gothic Pro;
              font-weight: normal;
              color: #CCCCCC;
          }
          .fiveCol{
              flex:1;
              font-size: 22px;
              font-family: ITC Avant Garde Gothic Pro-Demi, ITC Avant Garde Gothic Pro;
              font-weight: normal;
              color: #CCCCCC;
          }
          .sixCol{
              flex:1.2;
              font-size: 20px;
              font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
              font-weight: 500;
              color: #E4CA91;
          }
          .actionInfo{
              flex:1;
              text-align: right;
              span{
                  display: inline-block;
                  margin-left:20px;
                  font-size: 20px;
                  font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
                  font-weight: 500;
                  color: #E4CA91;
                  cursor: pointer;
              }
          }
          .topSty{
              margin-top:16px;
              span{
                cursor: pointer;
              }
          }
      }
  }
    </style>
    <style>

    #qxTabPage .el-pagination button:disabled,
    #qxTabPage .el-pagination .btn-prev,
    #qxTabPage .el-pagination .btn-next,
    #qxTabPage .el-pager li,
    #qxTabPage .el-pagination__editor.el-input .el-input__inner,
    #qxTabPage .el-pagination .el-select .el-input .el-input__inner{
      background: #141625;
    }
    </style>

